import React, {Component} from 'react';
import '../App.css';

export default class InputLanguage extends Component {
    render() {
        return (
            <label>{this.props.lang.split(';')[0].toUpperCase()}<input name='language' type="radio" value={this.props.lang}
                                                         checked={this.props.checked === this.props.lang}
                                                         onChange={this.props.handleChange}/></label>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/inputLanguage.js